import React from "react";
import Row from "../Layout/Row";
import NTMButtonRow from "./NTMButtonRow";
import { addIcon } from "img/icons";
import style from "./_fands.module.scss";


export default class FilterAndSearch extends React.Component {
	state={};

	render() {
		let {addElement, filter, onFilter, onSearch, allButton, selected} = this.props;

		return <Row>
			<NTMButtonRow
				buttons={filter}
				onClick={onFilter}
				allButton={allButton}
				selected={selected}
			/>
			{
				addElement &&
					<div className={style.element} onClick={addElement}>
						<div className={style.wrapper}>
							<img src={addIcon} alt={"Crea utente"} />
							<span>AGGIUNGI</span>
						</div>
					</div>
			}
			<div className={style.element}>
				<input className={style.searchbar} type={"text"} placeholder={"Cerca"} value={this.state.search} onChange={e => {
					this.setState({search: e.target.value});
					onSearch(e.target.value);
				}}/>
			</div>
		</Row>
	}
}
